module.exports = __webpack_public_path__ + "img/stamp.a8f02676.png";